import { useState } from "react";
import "./AdminTitulo.css";

function AdminTitulo({
  tituloObj,
  subtituloObj,
  onClose,
  onAtualizado,
}) {
  const [itemEditando, setItemEditando] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [salvando, setSalvando] = useState(false);

  const abrirEdicao = (item) => {
    setItemEditando(item);
    setDescricao(item?.descricao || "");
  };

  const salvar = async () => {
    if (!itemEditando) return;

    try {
      setSalvando(true);

      const response = await fetch(
        "https://app.eliandroalimentos.com.br/api/titulos/editardescricao",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: itemEditando.id,
            descricao,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Erro ao salvar");
      }

      await onAtualizado();

      setItemEditando(null);
    } catch (error) {
      alert("Erro ao salvar descrição");
      console.error(error);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="admin-overlay" onClick={onClose}>
      <div
        className="admin-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Editar Títulos</h3>

        {tituloObj && (
          <div className="admin-item">
            <span>{tituloObj.descricao}</span>

            <button
              onClick={() => abrirEdicao(tituloObj)}
            >
              Editar
            </button>
          </div>
        )}

        {subtituloObj && (
          <div className="admin-item">
            <span>{subtituloObj.descricao}</span>

            <button
              onClick={() => abrirEdicao(subtituloObj)}
            >
              Editar
            </button>
          </div>
        )}

        {itemEditando && (
          <div className="admin-edicao">
            <h4>Editar descrição</h4>

            <textarea
              value={descricao}
              onChange={(e) =>
                setDescricao(e.target.value)
              }
              rows={4}
            />

            <div className="admin-edicao-botoes">
              <button
                className="btn-cancelar"
                onClick={() => setItemEditando(null)}
              >
                Cancelar
              </button>

              <button
                className="btn-salvar"
                disabled={salvando}
                onClick={salvar}
              >
                {salvando
                  ? "Salvando..."
                  : "Salvar"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminTitulo;